import app from 'flarum/forum/app';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import username from '../../../../../vendor/flarum/core/js/src/common/helpers/username';
import Button from 'flarum/forum/components/Button';
import Stream from 'flarum/common/utils/Stream';
import icon from 'flarum/helpers/icon';

app.initializers.add('indigo/flarum-ext-custom-field', () => {
  console.log('[indigo/flarum-ext-custom-field] Hello, forum!')
//  document.querySelector("button.Button.FoFLogInButton.LogInButton--auth0.LogInButton.hasIcon").innerHTML = '<span class="Button-label">Use suas credenciais do VocallCenter </span>'

//alert("teste")


extend(SignUpModal.prototype, 'oninit', function() {
	this.empresa = Stream(this.attrs.empresa || '');
});

//extend(SignUpModal.prototype, 'onready', function() {
//	if (!this.attrs.empresa) {
//		this.$('[name=empresa]').select();}
//});

	
extend(SignUpModal.prototype, 'fields', function(items) {

 items.add('Empresa',
        m('.Form-group', [
            m('input.FormControl', {
                name: 'empresa',
                type: 'text',
                id: 'empresa',
                placeholder: 'Empresa',
            })
        ]),
    );
});


extend(SignUpModal.prototype, 'submitData', function (data) {
	//alert('teste');
	//console.log(data);
	data.empresa = document.getElementById('empresa').value;
	//data.empresa = this.empresa();
//	console.log(data);
//	alert(data.empresa);
	return data;
})

extend(UserCard.prototype, 'infoItems', function(items) {

	const empresa = this.attrs.user.attribute('empresa');

	items.add('empresa', m('span', [
		 icon('fas fa-address-card'), ' ', empresa
		  ]))

})

//document.querySelector("button.Button.FoFLogInButton.LogInButton--auth0.LogInButton.hasIcon").innerHTML = '<span class="Button-label">Use suas credenciais do VocallCenter </span>'

})


